import { useEffect, useRef } from 'react'

import type { FunnelStageKey } from '@/api/types'

import { stageButtonId } from './figures'

/**
 * Where focus goes once the URL has caught up with a stage choice: into the
 * detail when one opens from the funnel, back to the stage's button when it
 * closes. A `?stage=` link that arrives leaves focus where the page put it.
 */
export function useStageFocus(stage: FunnelStageKey | undefined) {
  const detail = useRef<HTMLDivElement>(null)
  const pending = useRef<FunnelStageKey | 'detail' | null>(null)
  useEffect(() => {
    const target = pending.current
    pending.current = null
    if (target === 'detail') detail.current?.focus()
    else if (target) document.getElementById(stageButtonId(target))?.focus()
  }, [stage])
  return {
    detail,
    after: (target: FunnelStageKey | 'detail') => {
      pending.current = target
    },
  }
}
